export default "__VITE_ASSET__CmctoGiX__"